<template>
    <div>

        <!-- 搜索框 -->
        <div class="search-box pt-12 df">
            <div>
                <!-- input 回车就查询 -->
                <el-input :placeholder="$t('请输入关键字')" v-model="search_key" @keyup.enter.native="getData()">
                    <i class="iconfont icon-sousuo lh-38 pr-16" slot="suffix" @click="getData()">
                    </i>
                </el-input>
            </div>
        </div>


        <!-- 活动列表 -->
        <div class="active-listcontent mt-10 df fww">
            <div class="list" v-for="(item, index) in dataList" @click="handleLink(item)" :key="index">
                <div class="img-box">
                    <el-image :src="item.ta_thumb" fit="cover">
                        <div slot="error" class="image-slot">
                            <img src="@/assets/images/news-default.png" alt="">
                        </div>
                    </el-image>

                    <div class="ri fn">
                        <el-button type="success" class="end" v-if="item.is_sign_up == 10">
                            {{ $t('活动已结束') }}
                        </el-button>
                        <el-button type="success" v-else-if="item.is_sign_up == 20">
                            {{ $t('即将举行') }}
                        </el-button>
                        <el-button type="success" v-else-if="item.is_sign_up == 30">
                            {{ $t('活动报名中') }}
                        </el-button>
                        <el-button type="success" v-else-if="item.is_sign_up == 40">
                            {{ $t('活动进行中') }}
                        </el-button>
                    </div>

                </div>
                <div class="list-box">
                    <div class="title mic-semblod one-text">{{ item.ta_title }}</div>
                    <div class="desc one-text" style="white-space: nowrap;">{{ item.ta_desc }}</div>
                    <div class="date-box df aic jcsb">
                        <div class="le over-h">
                            <div class="address one-text">
                                <span class="iconfont">&#xe61f;</span>{{ item.ta_city_text }}
                            </div>
                            <div class="date"><span class="iconfont">&#xe602;</span>{{ item.ta_start_time }}</div>
                        </div>
                        <div>
                            <el-button type="primary" class="qx-btn" @click="submitCancelSignUp($event, item.ta_id)">{{
                                $t('取消报名') }}</el-button>
                        </div>

                    </div>
                </div>
            </div>

            <!-- 暂无数据 -->

            <template v-if="dataList.length == 0">
                <div class="no-data">
                    <img src="@/assets/images/empty_data.png" alt="">
                    <p>{{ $t('暂无数据') }}</p>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import { getActivity } from "@api/usercenter";
import { setCancelSignUp } from "@api/active";
export default {
    data() {
        return {
            search_key: "",
            // 活动列表
            dataList: [

            ],
        }
    },
    created() {
        this.getData();
    },

    methods: {
        // 跳转详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            let target = {}
            // 判断是否是精英赛
            if (item.ta_kind == 30) {
                target = this.$router.resolve(str + '/challenge/info/' + item.ta_id)
            } else {
                target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
            }
            window.open(target.href, '_blank');
        },
        getData() {
            getActivity({ search_key: this.search_key }).then((res) => {
                if (res.status == '200') {
                    this.dataList = res.data.data;
                }
            })
        },

        // 取消报名
        submitCancelSignUp(e, id) {
            // 阻止冒泡
            e.stopPropagation();
            setCancelSignUp({ ta_id: id, dataOrigin: true }).then((res) => {
                if (res.status == '200') {
                    this.$message.success(this.$t('取消报名成功'));
                    this.getData();
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.search-box {
    ::v-deep() {
        .el-input--suffix .el-input__inner {
            width: 360px;
            border-radius: 30px;
        }
    }
}

.qx-btn {
    border-radius: 30px;
    height: 32px;
    line-height: 30px;
    padding: 0 16px;
    font-size: 12px;
}

// 活动列表
.active-listcontent {
    padding-bottom: 40px;

    .list {
        width: calc(50% - 10px);
        height: 430px;
        border-radius: 6px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
        background: rgb(255, 255, 255);
        margin-top: 20px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
            ::v-deep() {
                .el-image {
                    transform: scale(1.1);
                }
            }

            .list-box .title {
                color: #B7251E;
            }
        }

        .img-box {
            width: 100%;
            height: 300px;
            overflow: hidden;
            position: relative;

            .ri {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 38px;
                background: rgba(0, 0, 0, 0.18);
            }

            button {
                background: transparent;
                border: none;
                text-align: right;
            }

            ::v-deep() {
                .image-slot {
                    height: 100%;
                }
            }



            ::v-deep .el-image {
                width: 100%;
                height: 100%;
                transition: all 1s;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .list-box {
            padding: 16px;

            .title {
                color: rgb(25, 25, 25);
                font-size: 18px;
                font-weight: 400;
                line-height: 28px;
            }

            .desc {
                color: rgb(89, 89, 89);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                height: 22px;
                margin-top: 8px;
            }

            .date-box {
                padding-top: 4px;

                .le {
                    color: rgb(89, 89, 89);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;

                    span {
                        font-size: 14px;
                        margin-right: 5px;
                    }
                }

                // .ri {
                //     ::v-deep() {
                //         .el-button {
                //             border: none;
                //             color: #1872FD;
                //             min-width: 96px;
                //             height: 36px;
                //             border-radius: 20px;
                //             background: rgb(231, 239, 255);
                //             padding: 0 16px;
                //         }
                //     }

                //     .end {
                //         color: #6d7177;
                //         background: #ffffff;
                //         border: 1px solid #6d7177;
                //     }
                // }
            }
        }

        &:nth-child(2n) {
            margin-left: 20px;
        }

        // &:nth-child(3n-1) {
        //     margin-left: 20px;
        // }
    }
}
</style>